import * as Constants from './constants'

const initialState = {
  list: [],
  item: {},
  type: Constants.DASHBOARD_LIST_INITING,
  listRequesting: false,
  requesting: false,
  successful: false,
  messages: [],
  errors: [],
}

const reducer = function dashboardReducer(state = initialState, action) {
  switch (action.type) {
    case Constants.DASHBOARD_LIST_REQUESTING:
      return {
        list: [],
        item: {},
        type: action.type,
        listRequesting: true,
        requesting: false,
        successful: false,
        messages: [{
          body: 'Fetching data...!',
          time: new Date(),
        }],
        errors: [],
      }

    case Constants.DASHBOARD_LIST_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        list: action.data,
        item: action.data,
        listRequesting: false,
        requesting: false,
        successful: true,
        messages: [],
        errors: [],
      }

    case Constants.DASHBOARD_LIST_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        list: [],
        item: {},
        listRequesting: false,
        requesting: false,
        successful: false,
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }
    case Constants.DASHBOARD_SINHNHAT_LIST_REQUESTING:
      return {
        list: [],
        item: {},
        type: action.type,
        listRequesting: true,
        requesting: false,
        successful: false,
        messages: [{
          body: 'Fetching data...!',
          time: new Date(),
        }],
        errors: [],
      }

    case Constants.DASHBOARD_SINHNHAT_LIST_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        list: action.data,
        item: action.data,
        listRequesting: false,
        requesting: false,
        successful: true,
        messages: [],
        errors: [],
      }

    case Constants.DASHBOARD_SINHNHAT_LIST_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        list: [],
        item: {},
        listRequesting: false,
        requesting: false,
        successful: false,
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }
    default:
      return state
  }
}

export default reducer



// WEBPACK FOOTER //
// ./src/views/Dashboard/reducer.js